module.exports = __webpack_public_path__ + "p.no2.f8c22508.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/p.no2.jpg
// module id = yLtP
// module chunks = 0